module.exports = __webpack_public_path__ + "static/img/mercadopago.028fc6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/spa/pagos/mercadopago.png
// module id = LnSs
// module chunks = 1